$(document).ready(function () {
    $(".overzicht-inschrijvingen-open").click(function () {
        if ($(this).hasClass('fa-caret-right')) {
            $(this).removeClass('fa-caret-right');
            $(this).addClass('fa-caret-down');
           $(this).parent().parent().parent().children().eq($(this).parent().parent().index() + 1).children('td').children(".overzicht-inschrijvingen-info").slideToggle(300);
        } else {
            $(this).addClass('fa-caret-right');
            $(this).removeClass('fa-caret-down');
            $(this).parent().parent().parent().children().eq($(this).parent().parent().index() + 1).children('td').children(".overzicht-inschrijvingen-info").slideToggle(300);

        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./js/OverizchtInschrijvingen.js
// module id = 10
// module chunks = 0